export const STUDENT_GROUP_TYPE = "student"
export const ADMIN_STAFF_GROUP_TYPE = "admin-staff"
export const ADMIN_STUDENT_GROUP_TYPE = "admin-student"
export const INVALID_GROUP_TYPE = "admin-student"

const getMemberByType = (mainMembers, type) => {
  return mainMembers.find(member => member.type === type);
};

export const getMainGroupMember = (userRole, groupType, mainMembers) => {
  switch (userRole) {
    // Admin Role
    case "admin":
      if (groupType === STUDENT_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'student');
      }
      if (groupType === ADMIN_STAFF_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'staff');
      }
      if (groupType === ADMIN_STUDENT_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'student');
      }
      return INVALID_GROUP_TYPE;

    // Staff Role
    case "staff":
      if (groupType === STUDENT_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'student');
      }
      if (groupType === ADMIN_STAFF_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'admin');
      }
      return INVALID_GROUP_TYPE;

      // Parent Role
      case "parent":
      if (groupType === STUDENT_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'student');
      }
      if (groupType === ADMIN_STUDENT_GROUP_TYPE) {
        return getMemberByType(mainMembers, 'admin');
      }
      return INVALID_GROUP_TYPE;
    default:
      return INVALID_GROUP_TYPE;
  }
};
